import React from 'react';

const MwTextArea = ({ id, value, onChange, label, placeholder, rows, classNamePrivate, disabled = false }) => {
    return (
        <>
            {label && (
                <label className="text-xs  font-[700] px-1 text-[#261759]" htmlFor={id}>
                    {label}
                </label>
            )}
            <textarea
                className={`text-xs font-[600] text-[#261759] w-full rounded-md border border-[#8D82B6]/50 p-2 ${classNamePrivate || ''}`}
                id={id}
                name={id}
                value={value}
                onChange={onChange}
                disabled={disabled}
                placeholder={placeholder}
                rows={rows}
                style={{ resize: 'none' }}
            />
        </>
    );
};

export default MwTextArea;
